// This is a stub for ApexCharts to prevent errors from occurring
window.ApexCharts = function() {
  return {
    render: function() { return Promise.resolve(); },
    exec: function() { return Promise.resolve(); },
    updateOptions: function() { return Promise.resolve(); },
    updateSeries: function() { return Promise.resolve(); },
    destroy: function() { return Promise.resolve(); }
  };
};